module.exports = __webpack_public_path__ + "img/card.1a4a3678.svg";